import { render } from "./PageNotFound.vue?vue&type=template&id=585b42c2"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script